import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyCcU5OEYD4IXTruODMIgFqV-5CRQ9DAFWY',
  authDomain: 'grounded-coffee-co.firebaseapp.com',
  projectId: 'grounded-coffee-co',
  storageBucket: 'grounded-coffee-co.firebasestorage.app',
  messagingSenderId: '765548878309',
  appId: '1:765548878309:web:36e964abc4bcd4f956b70c',
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
